import apiClient from "./apiClient";

/**
 * Get comments for a post
 *
 * GET /comments/{postId}/comments?page=0&size=20
 */
export async function getComments(
    postId,
    page = 0,
    size = 20
) {
    const response = await apiClient.get(
        `/comments/posts/${postId}`,
        {
            params: {
                page,
                size
            }
        }
    );

    return response.data;
}


/**
 * Add comment
 *
 * POST /comments/{postId}/comments
 */
export async function createComment(
    postId,
    content
) {
    const response = await apiClient.post(
        `/comments/posts/${postId}`,
        {
            content
        }
    );

    return response.data;
}


/**
 * Update comment
 *
 * PUT /comments/{commentId}
 */
export async function updateComment(
    commentId,
    content
) {
    const response = await apiClient.put(
        `/comments/${commentId}`,
        {
            content
        }
    );

    return response.data;
}


/**
 * Delete comment
 *
 * DELETE /comments/{commentId}
 */
export async function deleteComment(
    commentId
) {
    await apiClient.delete(
        `/comments/${commentId}`
    );
}